/**
 * Utility functions for platform name processing and display
 */

/**
 * Get display-friendly name for platforms
 * Converts technical platform names to user-friendly display names
 */
export const getPlatformDisplayName = (platformName: string): string => {
  if (platformName.toLowerCase() === 'zoom_phone') {
    return 'Zoom';
  }
  if (platformName.toLowerCase().includes('ringcentral production')) {
    return 'RingCentral';
  }
  if (platformName.toLowerCase().includes('ringcentral')) {
    return platformName.replace(/ringcentral/gi, 'RingCentral');
  }
  if (platformName.toLowerCase() === 'dialpad') {
    return 'Dialpad';
  }
  return platformName;
};

/**
 * Check if a platform should be hidden from display
 * Currently filters out zoom_users platform
 */
export const shouldHidePlatform = (platformName: string): boolean => {
  return platformName.toLowerCase() === 'zoom_users';
};